import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { WorkShiftService } from '../../services/work-shift.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-create-work-shift',
    templateUrl: './create-work-shift.component.html',
    styleUrls: ['./create-work-shift.component.css', '../../app.component.css']
})

export class CreateWorkShiftComponent implements OnInit {

    workShiftForm: FormGroup;
    workShift: any;

    pickatimeParams = Utils.pickatimeParams();

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private workShiftService: WorkShiftService) {
    }

    ngOnInit() {
        this.workShiftForm = this.formBuilder.group({
            name: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', [Validators.required]]
        });
    }

    onSubmitWorkShift() {
        this.workShift = this.saveWorkShift();

        this.workShiftService.postWorkShift(this.workShift).then(res => {
            this.workShiftForm.reset();

            this.router.navigate(['/work_shifts']);
        });
    }

    saveWorkShift() {
        const currentDate = new Date();

        const workShitJson = {
            active: 1,
            createdAt: currentDate,
            endTime: this.workShiftForm.get('endTime').value,
            name: this.workShiftForm.get('name').value,
            startTime: this.workShiftForm.get('startTime').value,
            updatedAt: currentDate
        };

        return workShitJson;
    }

}
